import { render } from "./singlePartnerFeature.vue?vue&type=template&id=416eb0b2&scoped=true"
import script from "./singlePartnerFeature.vue?vue&type=script&lang=js"
export * from "./singlePartnerFeature.vue?vue&type=script&lang=js"

import "./singlePartnerFeature.vue?vue&type=style&index=0&id=416eb0b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416eb0b2"]])

export default __exports__